import React from 'react';
import PropTypes from 'prop-types';
import {
  WithStore,
} from 'pure-react-carousel';

/**
 * Renders text for the currentSlide. Useful for displaying text as overlay.
 * It is intended to be used inside of a <CarouselProvider /> component from
 * pure-react-carousel.
 *
 * https://github.com/express-labs/pure-react-carousel#withstore-higher-order-component
 */
export class Description extends React.PureComponent {
  render() {
    const {
      descriptions,
      currentSlide,
      className,
    } = this.props;

    const text = descriptions[currentSlide];

    // If no text, don't render anything
    if (!text) {
      return null;
    }

    return (
      <div className={`carouselDescription ${className}`}>
        <span className='description'>{text}</span>
      </div>
    );
  }
}

Description.propTypes = {
  descriptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentSlide: PropTypes.number.isRequired,
  className: PropTypes.string,
};

Description.defaultProps = {
  className: null,
};

const CarouselDescription = WithStore(Description, (state) => ({
  currentSlide: state.currentSlide,
}));

export default CarouselDescription;
